export default "__VITE_ASSET__df402fbf__"